export const SIGN_IN = 'SIGN_IN'
export const LOG_OUT = 'LOG_OUT'
export const ADD_TO_CART = "ADD_TO_CART"